import dayjs from 'dayjs';
import i18n from './components/i18n';
import { SemanticICONS } from 'semantic-ui-react';
import { RouteTypes } from './routes/constants';

export const optionsLimit = [
  {
    value: 5,
    text: '5'
  },
  {
    value: 10,
    text: '10'
  },
  {
    value: 20,
    text: '20'
  },
  {
    value: 30,
    text: '30'
  },
  {
    value: 40,
    text: '40'
  },
  {
    value: 50,
    text: '50'
  }
]

export const MINIMUM_LENGTH_PASSWORD = 8

export const passwordRegex = /^(?=.*[0-9])(?=.*[^\p{L}\d])(?=.*[A-Z])(?=.*[a-z])/u

export const passwordRegexWithoutSpecChar = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])/

export const MAX_LENGTH_PASSWORD = 32

interface IFiles {
  code?: string;
  fileType?: string;
  filename?: string;
  id?: string | number;
  label?: string;
  link?: null;
  name?: string;
  originalFilename?: string;
  status: number | string;
  type: string;
}
type ISetingsData = {
  code?: string;
  companyName?: string;
  files?: [IFiles];
  firstColor?: string;
  headerTitle?: string;
  chEnv: number;
  id: number;
  label: string;
  languageId: number;
  secondColor: string;
  hasMicrosoftAzureLogin: number;
  version: {
    version: string;
    date: string;
  };
}

export type ThemeType = ISetingsData & {
  logoTitle: string
  favIcon: string
}

export const ADMIN_ROLE_SLUG = 'admin'

export const BASE_PRICE_TEXT_SLUG = 'base_price_text'

export const CLOUD_STORAGE_SLUG = 'cloud_storage_text'

export const LIGHT_USER_ROLE_SLUG = 'light_user'

export const FARMER_MANAGER_ROLE_SLUG = 'farmer_manager'

export const OPERATIVE_ROLE_SLUG = 'operative_user'

export const FARMER_ROLE_SLUG = 'user'

export const IFE_ROLE_SLUG = 'ife'

export const MILK_MONEY_ACCOUNT_SLUG = 'milk_money_accounting'

export const MANAGER_ROLE_SLUG = 'manager'

export const COOL_FARM_SLUG = 'cool_farm_tool'

export const MILK_FIXED_SLUG = 'milk_fixed_price_stock_exchange'

export const FAT_PROTEIN_SLUG = 'milk_fixed_price_fat_and_protein'

export const MILK_STOCK_EXCHANGE = 'milk_stock_exchange'

export const FUTURE_CONTRACTS_SLUG = 'future_contracts'

export const CO2_LFL_SLUG = 'co2_lfl_climate_check'

export const CLIMATE_CHECK_SLUG = 'climate_check'

export const CLIMA_PROGRAM_SLUG = 'climate_program'

export const getFarmersFilters = () => [
  {
    key: 'terminationDate',
    placeholder: i18n.t('Cancellation date'),
    options: [
      {
        value: 1,
        text: i18n.t('Cancellation date is set')
      },
      {
        value: 0,
        text: i18n.t('Cancellation date is not set')
      }
    ]
  },
  {
    key: 'lastDeliveryDate',
    placeholder: i18n.t('Last delivery date'),
    options: [
      {
        value: 1,
        text: i18n.t('Last delivery date is set')
      },
      {
        value: 0,
        text: i18n.t('Last delivery date is not set')
      }
    ]
  },
  {
    key: 'stateId',
    placeholder: i18n.t('States'),
    optionsKey: 'states'
  },
  {
    key: 'periods',
    placeholder: i18n.t('Period under consideration'),
    optionsKey: 'periods',
    moduleSlug: CO2_LFL_SLUG
  },
  {
    key: 'milkTypeId',
    placeholder: i18n.t('Milk types'),
    optionsKey: 'milkTypes'
  }
]

export const getFarmersFilterInputs = () => [
  {
    key: 'yearlyAmountFrom',
    placeholder: i18n.t('Max of trading amount (from)')
  },
  {
    key: 'yearlyAmountTo',
    placeholder: i18n.t('Max of trading amount (to)')
  },
  {
    key: 'confirmedAmountFrom',
    placeholder: i18n.t('Fixed price amount  (from)')
  },
  {
    key: 'confirmedAmountTo',
    placeholder: i18n.t('Fixed price amount  (to)')
  }
]

interface FilterOption {
  value: number | string;
  text: string;
}

interface SelectFilter {
  key: string;
  placeholder: string;
  options?: FilterOption[]; // For filters with explicit options
  optionsKey?: string; // For filters that get options from a key
  moduleSlug?: string; // Optional module slug for specific filters
}

interface InputFilter {
  key: string;
  options?: FilterOption[];
  placeholder: string;
  moduleSlug?: string;
}

export type FilterType = SelectFilter | InputFilter;

export const TRADING_VOLUME_ID = 'search-trading-volume-activity'

export const getReportingFilters = () => [
  {
    key: 'yearFrom',
    placeholder: 'Year from',
    monthKey: 'monthFrom',
    monthPlaceholder: 'Month from',
    type: 'date'
  },
  {
    key: 'yearTo',
    placeholder: 'Year to',
    monthKey: 'monthTo',
    monthPlaceholder: 'Month to',
    type: 'date'
  },
  {
    key: 'tradingVolumeTypeId',
    placeholder: 'HM type. choose',
    labelValue: 'HM type',
    type: 'select',
    optionsKey: 'tradingVolumeTypes',
    filterId: TRADING_VOLUME_ID
  },
  {
    key: 'customFilterId',
    placeholder: 'Individual filters',
    type: 'select',
    optionsKey: 'customFilters',
    filterId: 'individual-filters-trading-activity'
  }
]

export const ESCAPE_KEY_CODE_VALUE = 27

export const imageTypes = ['png', 'jpeg', 'jpg', 'gif', 'bmp']
export const videoTypes = ['avi', 'mpeg', 'mpg', 'mp4', 'mov', 'wmv']
export const pdfType = 'pdf'
export const googleDocsTypes = ['doc', 'docx', 'xlsx', 'pdf', 'txt']
export const DAIRY_USERS_PROFILE_COUNT_USER_ID = 'dairy-profile-count-users'

export const applicationPdfType = 'application/pdf'

export function daysOfWeek(): string[] {
  const daysOfWeekend = [];
  for (let i = 0; i < 7; i++) {
    const day = dayjs().startOf('week').add(i, 'day').format('dddd');
    daysOfWeekend.push(day);
  }
  return daysOfWeekend
}

export const milkSamplesIDs = {
  allIndividual: 'all-individual-values',
  farmer: 'farmers-average-values',
  dairy: 'dairy-average-values',
  dailyValues: 'daily-values',
  pseudom: 'pseudomonads-values'
}

// Regex pattern to match the format HH:mm
export const timeRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

export const SURVEY_STATUS_KEYS = {
  all: 'actual',
  defined: 0,
  planned: 1,
  live: 2,
  completed: 3
}

export const PRICE_CHANGE_STATUS_SLUGS = ['defined', 'scheduled']

export function getFarmerTableColumnHeaders(amountUnit) {
  return [
    {
      name: i18n.t('Supplier No.'),
      key: 'supplierNo',
      type: 'calendar',
      sorted: 'desc',
      link: `${RouteTypes.DAIRY_FACTORY_FARMERS_SHOW}#profile-details`
    },
    {
      name: i18n.t('Company name'),
      key: 'companyName',
      type: 'link',
      link: `${RouteTypes.DAIRY_FACTORY_FARMERS_SHOW}#profile-details`,
      sorted: 'asc'
    },
    {
      name: i18n.t('Farmers group'),
      key: 'farmerGroupName',
      sorted: 'asc'
    },
    {
      name: i18n.t('Emission factor (kg CO2e / kg FPCM)'),
      key: 'soldMilkEconomicAllocationFpcmIdf',
      type: 'number-or-value',
      unit: 'kg CO2e / kg FPCM',
      decimalScale: 2,
      sorted: 'desc'
    },
    {
      name: i18n.t('Yearly amount (in {{amountUnit}})', { amountUnit }),
      key: 'amount',
      sorted: 'desc',
      type: 'number'
    },
    {
      name: i18n.t('Max of trading amount (in {{amountUnit}})', { amountUnit }),
      key: 'yearlyAmount',
      sorted: 'desc',
      type: 'number'
    },
    {
      name: i18n.t('Fixed price amount (in {{amountUnit}}) / [in %]', { amountUnit }),
      key: 'confirmedAmount',
      sorted: 'desc',
      type: 'confirmWithPercent'
    },
    {
      name: i18n.t('Remaining amount (in {{amountUnit}}) / [in %]', { amountUnit }),
      key: 'confirmedAmount',
      type: 'remaining-farmer'
    },
    {
      name: i18n.t('Actions')
    }
  ];
}

export function getOnlyFarmerRelatedTableHeaders() {
  return [
    {
      name: i18n.t('Supplier No.'),
      key: 'supplierNo',
      link: `${RouteTypes.DAIRY_FACTORY_FARMERS_SHOW}#profile-details`,
      type: 'calendar',
      sorted: 'asc'
    },
    {
      name: i18n.t('Company name'),
      key: 'companyName',
      type: 'link',
      link: `${RouteTypes.DAIRY_FACTORY_FARMERS_SHOW}#profile-details`,
      sorted: 'asc'
    },
    {
      name: i18n.t('Farmers group'),
      key: 'farmerGroupName',
      sorted: 'asc'
    },
    {
      name: i18n.t('Actions')
    }
  ]
}

export function getFarmerTableCo2Headers() {
  return [
    {
      name: i18n.t('Supplier No.'),
      key: 'supplierNo',
      link: `${RouteTypes.DAIRY_FACTORY_FARMERS_SHOW}#profile-details`,
      type: 'calendar',
      sorted: 'asc'
    },
    {
      name: i18n.t('Company name'),
      key: 'companyName',
      type: 'link',
      link: `${RouteTypes.DAIRY_FACTORY_FARMERS_SHOW}#profile-details`,
      sorted: 'asc'
    },
    {
      name: i18n.t('Farmers group'),
      key: 'farmerGroupName',
      sorted: 'asc'
    },
    {
      name: i18n.t('Emission factor (kg CO2e / kg FPCM)'),
      key: 'soldMilkEconomicAllocationFpcmIdf',
      type: 'number-or-value',
      unit: 'kg CO2e / kg FPCM',
      decimalScale: 2,
      sorted: 'desc'
    },
    {
      name: i18n.t('Actions')
    }
  ];
}

const translations = [
  i18n.t('Search'),
  i18n.t('Price From'),
  i18n.t('Exchange ID'),
  i18n.t('Contract Nr. from'),
  i18n.t('Price To'),
  i18n.t('With trading slot?'),
  i18n.t('Trading year'),
  i18n.t('Farmer / Supplier number'),
  i18n.t('Fat (in %) from'),
  i18n.t('Fat (in %) to'),
  i18n.t('Protein (in %) from'),
  i18n.t('Protein (in %) to'),
  i18n.t('Germ count from'),
  i18n.t('Germ count to'),
  i18n.t('Cell count from'),
  i18n.t('Cell count to'),
  i18n.t('Urea from'),
  i18n.t('Urea to'),
  i18n.t('Inhibitor'),
  i18n.t('Contract Nr. To'),
  i18n.t('Commodity ID'),
  i18n.t('Year from'),
  i18n.t('Year to'),
  i18n.t('Month from'),
  i18n.t('Month to'),
  i18n.t('Trading volume types'),
  i18n.t('Search farmer group'),
  i18n.t('Search farmers'),
  i18n.t('HM type. choose'),
  i18n.t('Select type of milk'),
  i18n.t('HM type')
]

type ElementType = 'select' | 'checkbox' | 'input';

interface FormElementBase {
  placeholder?: string;
  key: string;
  type: ElementType;
  icon?: SemanticICONS;
  labelKey?: string;
}

export interface SelectStoneXElement extends FormElementBase {
  type: 'select';
  optionsKey: string;
}

export interface InputStoneXElement extends FormElementBase {
  type: 'input';
  typeInput?: string;
}

export interface CheckboxStoneXElement extends FormElementBase {
  type: 'checkbox';
  label: string;
}

export type StoneXCheckedFilterType = SelectStoneXElement | InputStoneXElement | CheckboxStoneXElement;

export const stoneXFilters: StoneXCheckedFilterType[] = [
  {
    placeholder: 'Search...',
    type: 'input',
    key: 'search',
    icon: 'search'
  },
  {
    placeholder: 'Trading month',
    key: 'tradingMonth',
    type: 'select',
    optionsKey: 'months'
  },
  {
    placeholder: 'Trading year',
    key: 'tradingYear',
    type: 'select',
    optionsKey: 'years'
  },
  {
    placeholder: 'Exchange',
    key: 'exchangeId',
    type: 'select',
    optionsKey: 'exchanges',
    labelKey: 'name'
  },
  {
    placeholder: 'Commodity',
    key: 'commodityId',
    type: 'select',
    optionsKey: 'commodities'
  },
  {
    placeholder: 'Contract Nr. from',
    key: 'contractNoFrom',
    type: 'input'
  },
  {
    placeholder: 'Contract Nr. To',
    key: 'contractNoTo',
    type: 'input'
  },
  {
    placeholder: 'Price From',
    key: 'priceFrom',
    type: 'input',
    typeInput: 'number'
  }, {
    placeholder: 'Price To',
    key: 'priceTo',
    type: 'input',
    typeInput: 'number'
  },
  {
    label: 'With trading slot?',
    key: 'withTradingSlot',
    type: 'checkbox'
  }
]

export const milkSamplesFilters = [
  {
    placeholder: 'Farmer / Supplier number',
    type: 'input',
    key: 'search',
    icon: 'search',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.farmer,
      milkSamplesIDs.pseudom
    ]
  },
  {
    placeholder: 'Procurement month',
    key: 'date',
    type: 'select',
    optionsKey: 'months',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.dairy,
      milkSamplesIDs.farmer,
      milkSamplesIDs.pseudom
    ]
  },
  {
    placeholder: 'Fat (in %) from',
    key: 'fatFrom',
    type: 'input',
    subType: 'number',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.dairy,
      milkSamplesIDs.farmer
    ]
  },
  {
    placeholder: 'Fat (in %) to',
    key: 'fatTo',
    type: 'input',
    subType: 'number',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.dairy,
      milkSamplesIDs.farmer
    ]
  },
  {
    placeholder: 'Protein (in %) from',
    key: 'proteinFrom',
    type: 'input',
    subType: 'number',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.dairy,
      milkSamplesIDs.farmer
    ]
  },
  {
    placeholder: 'Protein (in %) to',
    key: 'proteinTo',
    type: 'input',
    subType: 'number',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.dairy,
      milkSamplesIDs.farmer
    ]
  },
  {
    placeholder: 'Germ count from',
    key: 'germCountFrom',
    type: 'input',
    subType: 'number',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.dairy,
      milkSamplesIDs.farmer
    ]
  },
  {
    placeholder: 'Germ count to',
    key: 'germCountTo',
    type: 'input',
    subType: 'number',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.dairy,
      milkSamplesIDs.farmer
    ]
  },
  {
    placeholder: 'Cell count from',
    key: 'cellCountFrom',
    type: 'input',
    subType: 'number',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.dairy,
      milkSamplesIDs.farmer
    ]
  },
  {
    placeholder: 'Cell count to',
    key: 'cellCountTo',
    type: 'input',
    subType: 'number',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.dairy,
      milkSamplesIDs.farmer
    ]
  },
  {
    placeholder: 'Inhibitor',
    key: 'inhibitor',
    type: 'select',
    optionsKey: 'inhibitorSelect',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.farmer
    ]
  },
  {
    placeholder: 'Urea from',
    key: 'ureaFrom',
    type: 'input',
    subType: 'number',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.dairy,
      milkSamplesIDs.farmer
    ]
  },
  {
    placeholder: 'Urea to',
    key: 'ureaTo',
    type: 'input',
    subType: 'number',
    filterDisplayIds: [
      milkSamplesIDs.allIndividual,
      milkSamplesIDs.dailyValues,
      milkSamplesIDs.dairy,
      milkSamplesIDs.farmer
    ]
  }
]

export const MILK_SAMPLES_FILTER_KEY = 'milkSamplesFilters'

export const SCHEDULED_STATUS = 'scheduled'

export const TRADING_SLOT_PREFIXES = {
  fixedPrice: 'fixed-price',
  stockExchange: 'stock-exchange',
  fatProtein: 'fat-protein'
}

export const tradingSlotModules = [MILK_FIXED_SLUG, FAT_PROTEIN_SLUG, MILK_STOCK_EXCHANGE]

export const co2Filters = () => [
  {
    placeholder: i18n.t('Period')
  },
  {
    placeholder: i18n.t('Types')
  },
  {
    placeholder: i18n.t('Search farmer group')
  },
  {
    placeholder: i18n.t('Search farmers')
  },
  {
    placeholder: i18n.t('Data collection')
  },
  {
    placeholder: i18n.t('Race')
  },
  {
    placeholder: i18n.t('Individual filter')
  }
]